export const newFactReducerStep1 = (state = {}, action) => {
  // console.log(
  //   action.payload,
  //   "is payload of addFact",
  //   state,
  //   "is state of fact"
  // );
  switch (action.type) {
    case "ADDFACTSTEP1":
      state = action.payload;
      return state;

    default:
      return state;
  }
};
export const newFactReducerStep3 = (state = [], action) => {
  
  switch (action.type) {
    case "ADDFACTSTEP3":
      state = action.payload;
      return state;

    default:
      return state;
  }
};
